module.exports = __webpack_public_path__ + "static/media/phone-company-icon.c185ac3b.svg";